// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '@shared/commons/DataCache';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { TerceraSideBarButton } from './SideBar/TerceraSideBarButton';
export class AlertsButton extends TerceraSideBarButton {
    constructor() {
        super();
        this.tooltipKey = 'screen.Alerts';
    }
    getType() {
        return ControlsTypes.AlertsButton;
    }
    oncomplete() {
        super.oncomplete();
        DataCache.AlertManager.OnAlertAdded.Subscribe(this.onAlertsNumberChanged, this);
        DataCache.AlertManager.OnAlertRemoved.Subscribe(this.onAlertsNumberChanged, this);
    }
    dispose() {
        DataCache.AlertManager.OnAlertAdded.UnSubscribe(this.onAlertsNumberChanged, this);
        DataCache.AlertManager.OnAlertRemoved.UnSubscribe(this.onAlertsNumberChanged, this);
        super.dispose();
    }
    onAlertsNumberChanged() {
        const count = DataCache.AlertManager.GetActiveCount();
        void super.set('counter', count);
    }
}
TerceraSideBarButton.extendWith(AlertsButton, {});
